/**
 * All Permissions for Configuration Operator role
 */
export const CONFIGURATION_OPERATOR_PERMISSIONS: string[] = [
  'dashboardView',

  // 'terminalCreate',
  'terminalView',
  'terminalDetail',
  'terminalNotes',
  'terminalEdit',
  'terminalConfigure',
  'terminalConfigureEditable',
  'terminalRemove',
  'terminalAssign',
  'terminalTemplateApply',

  'terminalBulkTemplateApply',
  'terminalBulkActionRestart',
  'terminalBulkActionPushConfig',
  'terminalBulkActionPullConfig',
  'terminalBulkActionResetConfig',
  'terminalBulkActionFactoryReset',
  'terminalBulkActionUpgradeConfig',
  'terminalBulkActionSetDomain',
  'terminalBulkActionSetType',

  'terminalActionRestart',
  'terminalActionPushConfig',
  'terminalActionPullConfig',
  'terminalActionForcePushConfig',
  'terminalActionResetConfig',
  'terminalActionFactoryReset',
  'terminalActionUpgradeConfig',
  'terminalActionTerminalType',
  'serviceMenu',
  // 'terminalAdvancedEdit',
  // 'terminalTransactions',

  // 'registrationCreate',
  // 'registrationView',
  // 'registrationEdit',
  // 'registrationFinalize',
  // 'registrationCancel',
  // 'registrationTRF',
  // 'registrationDeactivate',
  // 'registrationRemove',

  // 'transactionView',

  // 'eventView',
  // 'deliveryCreate',

  // 'assetView',
  // 'administrationView',

  // 'domainView',
  // 'domainCreate',
  // 'domainEdit',
  // 'domainRemove',
  // 'domainContractTypeView',
  // 'domainContractTypeEdit',
  // 'domainTerminalTypeView',
  // 'domainTerminalTypeEdit',
  // 'domainDataView',
  // 'domainDataEdit',
  // 'domainAssetView',
  // 'domainAssetEdit',

  // 'roleView',
  // 'roleCreate',
  // 'roleCreateInheritable',
  // 'roleEdit',
  // 'roleRemove',

  // 'userView',
  // 'userCreate',
  // 'userEdit',
  // 'userRemove',
  // 'userPasswordRequest',

  // 'templateView',
  // 'templateCreate',
  // 'templateEdit',
  // 'templateRemove',
  // 'templateConfigurationEdit',

  // 'contractCreate',
  // 'contractView',
  // 'contractEdit',
  // 'contractRemove',

  // 'taskView',
  // 'taskCreate',

  // 'terminalImport',
  // 'editNotes',
]
